<mat-card class="wsea-card" [ngClass]="{'wsea-card-no-card' : chatTableValue}">
    <cdk-virtual-scroll-viewport class="example-container" [itemSize]="52" [maxBufferPx]="1200" [minBufferPx]="400"
        [ngClass]="{ 'cdk-table-no-data-found' : (tableData)?.length === 0 }">
        <table mat-table [dataSource]="tableData" class="wsea-table">

            <!-- Dynamic Columns -->
            @for (col of cols; track col) {
            <ng-container [matColumnDef]="col">
                <th mat-header-cell *matHeaderCellDef [ngClass]="classes[col]?.class"
                    [innerHTML]="classes[col]?.label || col | titlecase">
                </th>
                <td mat-cell *matCellDef="let row" [ngClass]="classes[col]?.class">
                    @if (classes[col]?.isLink) {
                    <a class="link">{{ row[col] }}</a>
                    } @else if (classes[col]?.isAction) {
                    <button mat-flat-button [ngClass]="row.actionClass">
                        {{ row[col] | titlecase }}
                    </button>
                    } @else {
                    <span [ngClass]="classes[col]?.class">
                        {{ row[col] }}
                    </span>
                    }
                </td>
            </ng-container>
            }

            <!-- Rows -->
            <tr mat-header-row *matHeaderRowDef="cols; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: cols;" [ngClass]="row.rowClass"></tr>

        </table>
        @if ((tableData)?.length === 0) {
        <p class="no_data_found">No Data Found...!</p>
        }
    </cdk-virtual-scroll-viewport>

</mat-card>